module.exports = __webpack_public_path__ + "static/img/top10.420d2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top10.png
// module id = B9ui
// module chunks = 208